export const Pages = [
  {
    name: 'About Us',
    link: '/about',
    id: 'about'
  },
  {
    name: 'New Patients',
    link: '/newPatients',
    id: 'new-patients'
  },
  {
    name: 'Insurance',
    link: '/Insurance',
    id: 'insurance'
  },
  {
    name: 'Resources',
    link: '/resources',
    id: 'health-resources'
  },
  // {
  //   name: 'Current Illness',
  //   link: '/illness',
  //   id: 'current-illness'
  // },
  {
    name: 'Contact Us',
    link: '/contact',
    id: 'contact-us'
  },
  {
    name: 'Portal',
    link: '/portal',
    id: 'portal'
  },
  {
    name: 'Pay Bill',
    link: '/pay-bill',
    id: 'pay-bill'
  }
];


// WEBPACK FOOTER //
// ./src/components/common/nav/pages.js